import { createBrowserRouter, Route, createRoutesFromElements, RouterProvider } from "react-router-dom";
import { Authentication } from "./Authentication";
import { APIsHandler } from "./APIs"

//pages
import Home from "./Home"
import About from "./About"
import NotFound from "./NotFound";
import Verification from "./Verification";
import PainelControle from "./PainelControle";

//layouts
import RootLayout from "./RootLayout";
import Registration from "./Signup";
import { Shapefile } from "./Shapefile";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<RootLayout />}>
      <Route index element={<Home />}/>
      <Route path="sobre" element={<About />}/>
      <Route path="painel" element={<PainelControle />}/>
      <Route path="signup" element={<Registration />} />
      <Route path="verificacao" element={<Verification />} />
      <Route path="*" element={<NotFound />}/>
      
    </Route>
  )
);

function App() {
  return (
    <Authentication>
      <APIsHandler>
        <Shapefile>
          <RouterProvider router={router} />
        </Shapefile>
      </APIsHandler>
    </Authentication>
  );
}

export default App;


/*import './styles/App.css';
import Home from './Home';
import Signup from './Signup'
import { Authentication } from './Authentication';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

function App() {
  return (
    <Authentication>
      <Router>      
        <div className="App">
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            <Route exact path="/signup">
              <Signup />
            </Route>
          </Switch>
        </div>
      </Router>
    </Authentication>    
  );
}

export default App;
*/



//COM MAPA
/*import logo from './logo.svg';
import './App.css';
import { GoogleMap, useLoadScript, Marker } from '@react-google-maps/api';

const libraries = ['places'];
const mapContainerStyle = {
  width: '100vw',
  height: '100vh',
};
const center = {
  lat: -27.2905715, // default latitude
  lng: -54.6337262, // default longitude
};

function App() {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: 'AIzaSyBvfH06FPkeWnrVt9LIn7HpRd-l-AN07Ks',
    libraries,
  });
  if (loadError) {
    return <div>Error loading maps</div>;
  }

  if (!isLoaded) {
    return <div>Loading maps</div>;
  }
  return (
    <div>
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        zoom={10}
        center={center}
      >
        <Marker position={center} />
      </GoogleMap>
    </div>
  );
}

export default App;
 */
